import Modal from 'react-modal'
import ironFit, { liveSupport, staffs } from '../../../clients/iron-fit'

export const ReturningStaffAssignment: React.FC<{ isOpen: boolean, setIsOpen: any, returningSupportId: string }> = ({ isOpen, setIsOpen, returningSupportId }) => {
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    }

    const [support] = liveSupport.useLiveSupport(returningSupportId)
    const [staffDetails] = staffs.useStaff(support?.staffId)

    const api = ironFit._clients().api

    const assignStaff = async() => {
         try {
            const payload = {
                preferredStaffId: support?.staffId
            }
            await api.put(`/live-support/patients-transfer/${support?.patientId}`, payload)
            setIsOpen(false)
        } catch (e) {
            setIsOpen(false)
            throw e
        }
    }

    return (
        <Modal isOpen={isOpen} style={customStyles}>
            <div className="logout-modal d-flex flex-column align-items-center">
                <h5 className='font-weight mb-3'>Atribuir equipe de devolução</h5>
                <div className='text-black' style={{ color: 'black' }}>
                    Equipe anterior {staffDetails?.name}
                </div>
                <div className='btn-wrapper d-flex mt-3'>
                    <button type="button" className="btn custom-btn-primary" disabled={!(staffDetails?.name)} onClick={assignStaff}>
                        Atribuir
                    </button>
                    <button type="button" className="btn custom-btn-danger" onClick={() => setIsOpen(false)}>
                        Cancelar
                    </button>
                </div>
            </div>
        </Modal>
    )
}